import { DecimalPipe } from '@angular/common'
import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core'

@Component({
  selector: 'progress-bar',
  imports: [DecimalPipe],
  template: `
    <div class="bg-primary-300/30 flex items-center gap-2 rounded-full px-1.5 py-1">
      <div class="bg-primary-300/70 grow rounded-full">
        <div
          data-test="bar"
          class="shadow-button-inset block h-3 rounded-full"
          [style.background-color]="color()"
          [style.width.%]="width()"></div>
      </div>
      <span
        data-test="percentage"
        class="preset-body-4 text-white">
        {{ percentage() | number }}%
      </span>
    </div>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ProgressBar {
  percentage = input.required<number>()

  color = computed(() => {
    const percentage = this.percentage()

    if (percentage < 50) return '#E4364B'
    if (percentage < 80) return '#F7D72F'

    return '#00B575'
  })

  width = computed(() => {
    const percentage = this.percentage()

    if (percentage > 100) return 100
    if (percentage < 0) return 0

    return percentage
  })
}
